// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/Knowledge2017-Bold.ttf");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Knowledge2017';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
.o6940T {
  background: var(--surface-neutral-white);
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.o6940T h2 {
  display: flex;
  align-items: center;
  gap: 16px;
  font-family: 'Knowledge2017', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  margin: 0;
}
.o6940T h2 img {
  width: 21.5px;
  height: auto;
}
.HeEx2Q {
  position: relative;
}
.HeEx2Q button {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 0;
  border: 0;
  background: transparent;
  text-align: left;
  font-family: var(--font-family-base);
  font-size: 16px;
  line-height: 23px;
  font-weight: 500;
  color: var(--text-neutral-dark);
}
.HeEx2Q button img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.HeEx2Q button img:not(.mreVNH) {
  transform: rotate(180deg);
}
.HT0HQy {
  padding: 12px 0;
  font-size: 14px;
  line-height: 22px;
}
.HT0HQy p {
  margin: 0;
}
.HT0HQy strong {
  font-weight: 600;
}
@media (max-width: 767px) {
  .HeEx2Q button {
    height: auto;
    min-height: 48px;
  }
}

.HeEx2Q::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: #ccc;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BenefitMigrationPage/components/MigrationFaq.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+DAA+D;AACjE;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'Knowledge2017';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url('../assets/Knowledge2017-Bold.ttf') format('truetype');\n}\n.container {\n  background: var(--surface-neutral-white);\n  border-radius: 8px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.container h2 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-family: 'Knowledge2017', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 26px;\n  margin: 0;\n}\n.container h2 img {\n  width: 21.5px;\n  height: auto;\n}\n.item {\n  position: relative;\n}\n.item button {\n  width: 100%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 0;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  font-family: var(--font-family-base);\n  font-size: 16px;\n  line-height: 23px;\n  font-weight: 500;\n  color: var(--text-neutral-dark);\n}\n.item button img {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n.item button img:not(.expanded) {\n  transform: rotate(180deg);\n}\n.answer {\n  padding: 12px 0;\n  font-size: 14px;\n  line-height: 22px;\n}\n.answer p {\n  margin: 0;\n}\n.answer strong {\n  font-weight: 600;\n}\n@media (max-width: 767px) {\n  .item button {\n    height: auto;\n    min-height: 48px;\n  }\n}\n\n.item::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `o6940T`,
	"item": `HeEx2Q`,
	"expanded": `mreVNH`,
	"answer": `HT0HQy`
};
module.exports = ___CSS_LOADER_EXPORT___;
